var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 11H13.5V8C13.5 7.447 13.052 7 12.5 7C11.948 7 11.5 7.447 11.5 8V12C11.5 12.553 11.948 13 12.5 13H16.5C17.053 13 17.5 12.553 17.5 12C17.5 11.447 17.053 11 16.5 11ZM12.5 20C8.089 20 4.5 16.411 4.5 12C4.5 7.589 8.089 4 12.5 4C16.911 4 20.5 7.589 20.5 12C20.5 16.411 16.911 20 12.5 20ZM12.5 2C6.986 2 2.5 6.486 2.5 12C2.5 17.514 6.986 22 12.5 22C18.014 22 22.5 17.514 22.5 12C22.5 6.486 18.014 2 12.5 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.9cc690102f3fb351cd7a3f54658d9289.svg";
export { ForwardRef as ReactComponent };